import React, { useEffect, useState } from "react";
import { ProductCard } from "../ShopComponent/ProductCard";
import axiosFetch from "../../Helper/Axios";

export const ListProduct = () => {
  const [data, setData] = useState([]);

  const fetchData = async () => {
    try {
      const response = await axiosFetch({
        url: "product/",
        method: "GET",
      });

      console.log("RESPONSE =", response);
      console.log("DATA =", response.data);
      console.log("LENGTH =", response.data?.length);

      // SAFETY CHECK (VERY IMPORTANT)
      if (!response || !response.data) {
        setData([]);
        return;
      }

      setData(response.data);
    } catch (error) {
      console.log("FETCH ERROR:", error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
      <>
        <section id="products" className="section product">
          <div className="container">
            <p className="section-subtitle"> -- Organic Products --</p>
            <h2 className="h2 section-title">All Organic Products</h2>

            <ul className="grid-list">
              <h1>Total Products: {data.length}</h1>

              {data.map((item) => (
                  <ProductCard
                      key={item.productid}
                      id={item.productid}
                      name={item.productName}
                      description={item.description}
                      price={item.price}
                      img={item.img}
                  />
              ))}
            </ul>
          </div>
        </section>
      </>
  );
};